// extracted by mini-css-extract-plugin
export var filterIncDec = "_f5-0";
export var leftBorder = "_f5-1";
export var rightBorder = "_f5-2";
export var stringInput = "_f5-3";